import styled from "styled-components"
import is, { match } from "styled-is"

export const StyledHeading = styled.h2`
  font-size: ${(props) => props.theme.fontSizes.h4};
  line-height: ${(props) => props.theme.lineHeight.standard};
  color: ${(props) => props.color || props.theme.colors.textColor};
  font-weight: ${(props) => props.weight || 700};
  margin: 0.3em 0;
  /* Size Modifiers */
  ${match("size", "h1")`
    font-size: ${(props) => props.theme.fontSizes.h1};
  `}
  ${match("size", "h2")`
    font-size: ${(props) => props.theme.fontSizes.h2};
  `}
  ${match("size", "h3")`
    font-size: ${(props) => props.theme.fontSizes.h3};
  `}
  ${match("size", "h4")`
    font-size: ${(props) => props.theme.fontSizes.h4};
  `}
  ${match("size", "h5")`
    font-size: ${(props) => props.theme.fontSizes.h5};
  `}
  /* Style Modifiers */
  ${is("noMargin")`
    margin: 0;
  `}
  ${is("largeMargin")`
    margin: 0.8em 0;
  `}
  ${is("ttu")`
    text-transform: uppercase;
  `}
`

export const BodyCopy = styled.div`
  font-size: ${(props) =>
    props.size === "Large"
      ? props.theme.fontSizes.h2
      : props.size === "Medium"
      ? props.theme.fontSizes.h3
      : props.theme.fontSizes.bodyReg};
  color: ${(props) => props.theme.colors.textColor};
  line-height: ${(props) => props.theme.lineHeight.body};
  ul {
    margin-left: 0;
    text-align: left;
    padding-left: 20px;
  }
  p {
    margin: ${(props) => props.theme.spacers.small} auto;
  }
  ${is("measureStandard")`
		max-width: ${(props) => props.theme.measures.standard};
		margin: 0 auto;
	`}
  ${is("$measureLarge")`
		max-width: ${(props) => props.theme.measures.large};
		margin: 0 auto;
	`}
	@media ${(props) => props.theme.breakpoints.large} {
    ${(props) =>
      props.size === "Large" &&
      "font-size:" + props.theme.fontSizes.headingTwoDesktop};
  }
`
